// src/scroll/index.ts
var scrollIntoElementId = (id, options) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: "smooth", ...options });
  }
};
var scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

export {
  scrollIntoElementId,
  scrollToTop
};
//# sourceMappingURL=chunk-BHPIFSD2.mjs.map